import { css } from "@emotion/react"
import { above, below } from "@mkt/cp/src/styles/Breakpoints"
import { getDuration } from "@mkt/cp/src/styles/Functions"
import { animeReverseShow, fadeIn } from "@mkt/ui/styles/Keyframes"
import createRange from "@mkt/utils/createRange"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"

const itemAnimation = (valueList) => {
  const cssAnimation = {}
  valueList.forEach((item) => {
    cssAnimation[`&:nth-of-type(${item})`] = {
      animation: `${animeReverseShow} ${getDuration(0.75)} ${0.4 + item / 6}s
          linear forwards;`,
    }
  })

  return cssAnimation
}

export const item = css`
  opacity: 0;
  animation: ${fadeIn} ${getDuration(0.75)} 2s linear forwards;
  display: flex;
  flex-wrap: nowrap;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 24px;
  border: 1px solid ${colorsCP["neutral-20"]};
  border-radius: 16px;

  :not(:nth-of-type(1)) {
    margin-top: 24px;
  }

  ${below["m"]} {
    padding: 24px;
    flex-direction: column;
  }
  ${itemAnimation(createRange(1, 60))}
`
export const figure = css`
  line-height: 0;

  ${below["m"]} {
    padding: 0;
  }

  img {
    max-width: 190px;
    object-fit: contain;

    ${below["m"]} {
      margin-left: auto;
      margin-right: auto;
    }
  }
`
export const metadata = css`
  width: 100%;

  ${above["l"]} {
    flex-grow: 1;
    margin-left: 40px;
  }

  ${above["m"]} {
    padding: 20px 0;
  }
`
export const title = css`
  color: ${colorsCP["neutral-70"]};
  text-align: left;
`
export const benefits = css`
  display: flex;
  margin-top: 20px;

  ${below["m"]} {
    flex-direction: column;
    gap: 16px;
  }
`
export const benefit = css`
  ${below["m"]} {
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }

  + div {
    ${above["l"]} {
      margin-left: 100px;
    }
  }

  .cp-text {
    display: block;
    text-align: left;
    font-weight: 600;

    &--body-medium {
      ${below["m"]} {
        text-align: right;
      }
    }
  }
`
export const cta = css`
  min-width: 175px;
  text-align: center;

  ${above["l"]} {
    flex-grow: 0.2;
  }
  ${below["m"]} {
    width: 100%;
  }

  & > .iq-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
    font-weight: 400;
    line-height: 24px;
    gap: 5px;
  }

  .icon {
    width: 24px;
    height: 24px;
  }

  a {
    padding-top: 0px;
    padding-bottom: 0px;
    line-height: 1.4;
    text-decoration: none;
  }
`
export const highlightTag = css`
  color: #16181D;
  background-color: #94F0CF;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 21px;
  display: inline-block;
  border-radius: 16px;
  margin-bottom: 16px;

  ${below["m"]} {
    display: block;
    max-width: 205px;
    text-align: center;
    margin-inline: auto;
    margin-bottom: 24px;
  }

  strong {
    font-size: 14px;
    font-weight: 600;
    vertical-align: middle;

    ${below["m"]} {
      display: block;
    }

    ${above["m"]} {
      padding-right: 14px;
      margin-right: 14px;
      border-right: 1px solid #04D98C;
    }
  }
`
